

var admin = angular.module('admin', [
	'forms',
	//'forms.fields.position',   // requires 'uiGmapgoogle-maps'
    'forms.fields.daterange',
    'forms.fields.datelist',
	'forms.fields.tags',
	'admin.dialogs',
	"persistent",
	'ui.router',
	'ui.bootstrap',
	'ui.select',
	'monospaced.elastic',  // textarea autoresize
	'angularFileUpload',
	'ngFileUpload',  // (backreference) TODO choose one :)
	'angular-loading-bar'
])


angular.module('admin')
	.value('LoginFile', 'start.php')
	.service('LoginService', function(CurrentUser, LoginFile, $location, $browser) {
		this.requireUser = function() {
			// unauthenticated - redirect to login
			if (!CurrentUser.isLoggedIn()) {
				this.redirectToLogin();
			}
		}

		this.redirectToLogin = function(){
			if ($location.$$html5) {
				var base_href = $browser.baseHref()
				var current_location = window.location.href.substr(base_href.length);
				window.location = LoginFile + '/login/back/' + encodeURIComponent(current_location.replace(/\//g, '~'));
			} else {
				if (location.hash) {
					var current_location = location.href.replace(/^[^#]*\//, '')
					window.location = LoginFile + '#/login/back/' + encodeURIComponent(current_location.replace(/\//g, '~'));;
				} else {
					window.location = LoginFile
				}
			}
		}
	})
		
    // admin musi mieć usera
	.run(function(LoginService){
		// unauthenticated - redirect to login
		LoginService.requireUser()
		
	})
	.run(function($rootScope, FieldTplDir) {
		$rootScope.fieldTplDir = FieldTplDir;
	})
	.run(function($rootScope) {
		$rootScope.defaultCurrency = 'PLN';
	})
	// reemit events scripts/core/controller/mainController.js
	.run(function($rootScope, pinesNotifications, LoginService){
		$rootScope.$on('$stateChangeStart', function(event, toState, toParams, fromState, fromParams){
	  		console.log('$stateChangeStart');
	  		// could start angular-loading-bar or skylo
	  		$rootScope.$broadcast('$routeChangeStart');
		})
		$rootScope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams){
			console.log('$stateChangeSuccess');
			// could stop angular-loading-bar or skylo
	  		$rootScope.$broadcast('$routeChangeSuccess');
		})
		$rootScope.$on('$stateChangeError', function(event, toState, toParams, fromState, fromParams, error){
			console.log('$stateChangeError', toState, toParams, fromState, fromParams, error);
			// could stop angular-loading-bar or skylo
	  		$rootScope.$broadcast('$routeChangeError');
			pinesNotifications.notify({
			    title: 'An error occured while loading the object',
			    text: error.data? error.data.message: error,
			    type: 'error'
			});
			// on unauthorized error => redirect to login
			if (error.data && error.data.code == 401) {
				LoginService.redirectToLogin();
			}
		})
		$rootScope.$on('$stateNotFound', function(event, unfoundState, fromState, fromParams){ 
		    console.log('$stateNotFound', unfoundState); // "lazy.state"
		})
		
		$rootScope.$on('unauthorized', function() {
			LoginService.redirectToLogin();
		});
	})
	.config(function(cfpLoadingBarProvider) {
		cfpLoadingBarProvider.includeSpinner = false;
		cfpLoadingBarProvider.latencyThreshold = 600;
	})
	
	
	.config(function ($stateProvider) {
		// Use $stateProvider to configure your states.
		// see http://angular-ui.github.io/ui-router/sample/app/contacts/contacts.js
		$stateProvider

        ////////////
        // Module //
        ////////////
        
        .state("module", {
			// With abstract set to true, that means this state can not be explicitly activated.
			// It can only be implicitly activated by activating one of its children.
			abstract: true,
			
			// This abstract state will prepend '/objects/<page>' onto the urls of all its children.
			url: '/objects/{page:[a-zA-Z_\-]+}',
			
			//templateUrl: 'framework/partials/admin/module.html', 
			template: '<ui-view>', 
			
			resolve: {
				ListContext: function(ContextService, $stateParams){return ContextService.getContext($stateParams.page)},
			}
		})
		
		// Using a '.' within a state name declares a child within a parent.
        // So you have a new state 'list' within the parent 'module' state.
		.state("module.list", {
			url: '',  // this will become /objects/<page>, becouse it is parent's "objects/<page>" + ''
			resolve:  {
				BaseFilter: function(ListContext){return ListContext.fetchBaseFilter();}
			},
			// IMPORTANT: Now we have a state that is not a top level state. Its
			// template will be inserted into the ui-view within this state's
			// parent's template; so the ui-view within module.html. This is the
			// most important thing to remember about templates.
			templateProvider: function(ListContext, $templateFactory){ 
				return $templateFactory.fromUrl(ListContext.config.listTemplateUrl || 'framework/partials/admin/list.html'); 
			},
			//controller: 'ModuleListController as mCtrl',
			// instantiale configured controller
			/*
			controller: function($controller, $scope, ListContext, BaseFilter) {
				var ctrl = $controller(ListContext.config.controller, {$scope:$scope, ListContext:ListContext, BaseFilter:BaseFilter});
				$scope[ListContext.config.controllerAs] = ctrl;
			},
			*/
			controllerProvider: function(ListContext) {
				// injectable provider that return the controller or a string
				var controller = ListContext.config.listController || 'ModuleListController';
				var controllerAs = ListContext.config.listControllerAs || 'mCtrl';
				return controller + ' as ' + controllerAs;
			}
		})
		
		.state("module.create", {
			//url: '/new/:parentClass/:parentVid',  
			url: '/:parentVid/:refClass/new',  
			//templateUrl: 'framework/partials/admin/object-create.html',
			templateProvider: function(ListContext, $templateFactory){ 
				return $templateFactory.fromUrl(ListContext.config.createTemplateUrl || 'framework/partials/admin/object-createform.html'); 
			},
			params: {
				refClass: {
					value: null,
					squash: true
				},
				parentVid: {
					value: null,
					squash: true
				},
				defaults: {
					value: null  // optional object with default values
				}
			},
			resolve:  {
				ListContext: function(ListContext, $stateParams) {
					if ($stateParams.refClass == '$clone') {
						return ListContext;
					} else if ($stateParams.refClass) {
						return ListContext.getInstance($stateParams.parentVid).fetch().then(function(parent) {;
							return ListContext.getReferencedContext(parent, $stateParams.refClass);
						});
					} else {
						return ListContext;
					}
				},
				Object: function(ListContext /* this is the new peer-defined ListContext */, $stateParams){
					if ($stateParams.refClass == '$clone') {
						var original = ListContext.getInstance($stateParams.parentVid);
						return ListContext.cloneInstance(original);
					} else {
						return ListContext.fetchNewInstance($stateParams.defaults)
					}
				},
				createMode: function($stateParams) {return $stateParams.refClass == '$clone'? '$clone': true},
				ModesAllowed: function(Object, ListContext){
					return {
						info: false,
						edit: true,
						hist: false,
					}
				},
				Mode: function(){return 'edit';}
			},
			/*
			// prowizoryczny kontroler
			controller: 'ObjectPanelController',
			controllerAs: 'oCtrl'
			*/
			controllerProvider: function(ListContext) {
				// injectable provider that return the controller or a string
				var controller = ListContext.config.createController || 'ModuleObjectController';
				var controllerAs = ListContext.config.createControllerAs || 'mCtrl';
				return controller + ' as ' + controllerAs;
			}
		})

		.state("module.import", {
			url: '/import/:preset',  
			templateProvider: function(ListContext, $templateFactory){ 
				return $templateFactory.fromUrl(ListContext.config.importTemplateUrl || 'framework/partials/admin/object-import.html'); 
			},
			params: {
				preset: {
					value: 'default',
					squash: true
				}
			},
			resolve:  {
				ListContext: function(ListContext, $stateParams) {
					if ($stateParams.refClass) {
						return ListContext.getInstance($stateParams.parentVid).fetch().then(function(parent) {
							return ListContext.getReferencedContext(parent, $stateParams.refClass);
						});
					} else {
						return ListContext;
					}
				},
				TemplateObject: function(ListContext /* this is the new peer-defined ListContext */, $stateParams){
					return ListContext.fetchNewInstance($stateParams.defaults)
				},
			},
			controllerProvider: function(ListContext) {
				// injectable provider that return the controller or a string
				var controller = ListContext.config.createController || 'ModuleImportController';
				var controllerAs = ListContext.config.createControllerAs || 'mCtrl';
				return controller + ' as ' + controllerAs;
			}
		})
		
		.state("module.detail", {
			url: '/{vid:[^/]+}/{mode:[^/]+}',
			params:{
				mode: 'info',
			},
			//templateUrl: 'framework/partials/admin/object.html',
			resolve:  {
				ListContext: function(ListContext, $stateParams) {
					// apply effective time
					if ($stateParams.vid.match(/:/)) {
						var effective_time = $stateParams.vid.replace(/^[^:]*:/, '');
						return ListContext.withEffectiveTime(effective_time);
					} else {
						return ListContext;
					}
				},
				Object: function(ListContext, $stateParams){
					return ListContext.getInstance($stateParams.vid).fetch(false, ListContext.config.fetchLevel || 1);
				},
				createMode: function() {return false},
				ModesAllowed: function(Object, ListContext, $injector){
					var tabs = ListContext.getTabs();
					var modes = {}
					for (var t in tabs) {
						modes[tabs[t].name] = $injector.invoke(tabs[t].enabled, null, {Object:Object,Config:ListContext.config});;
					}
					var inline = ListContext.getRefs('inline');
					for (var k in inline) {
						modes[inline[k].name] = typeof inline[k].enabled == "function"? $injector.invoke(inline[k].enabled, null, {Object:Object,Config:ListContext.config}) : true;
					}
					return modes;
				},
				Mode: function(ModesAllowed, $stateParams){
					if (ModesAllowed[$stateParams.mode]) {
						return $stateParams.mode;
					} else {
						if (ModesAllowed.info) return 'info';
						if (ModesAllowed.edit) return 'edit';
						if (ModesAllowed.hist) return 'hist';
					}
				},
			},
			/*
			// prowizoryczny kontroler
			controller: 'ObjectPanelController',
			controllerAs: 'oCtrl'
			*/
			templateProvider: function(ListContext, $templateFactory){ 
				return $templateFactory.fromUrl(ListContext.config.objectTemplateUrl || 'framework/partials/admin/object.html'); 
			},
			controllerProvider: function(ListContext) {
				// injectable provider that return the controller or a string
				var controller = ListContext.config.objectController || 'ModuleObjectController';
				var controllerAs = ListContext.config.objectControllerAs || 'mCtrl';
				return controller + ' as ' + controllerAs;
			}
		})
		
		.state("module.detail.tab", {
			url: '/{tab:[^/]+}',
			resolve: {
				ListContext: function(ListContext, Object, $stateParams){return ListContext.getReferencedContext(Object, $stateParams.tab)},
				BaseFilter: function(ListContext) {return ListContext.fetchBaseFilter()}  // tODO
			},
			templateProvider: function(ListContext, $templateFactory){ 
				return $templateFactory.fromUrl(ListContext.config.tabTemplateUrl || 'framework/partials/admin/tab-list.html'); 
			},
			controllerProvider: function(ListContext) {
				var controller = ListContext.config.listController || 'ModuleListController';
				var controllerAs = ListContext.config.listControllerAs || 'tCtrl';
				return controller + ' as ' + controllerAs;
			}
		})
		

	})
